import { streetApi } from "src/config/axios";
import type { AxiosError } from "axios";
import customError from "./customError";

const toggleEventLikes = async (
    eventId: number,
    likesCount: number,
    handelSetOperatedLikesList: (
        eventId: number,
        isLikes: boolean,
        likeCount: number
    ) => void
) => {
    return streetApi
        .post(`/events/${eventId}/toggle-like`)
        .then((response) => {
            const massage = response.data.message;
            switch (massage) {
                case "Liked successfully.":
                    handelSetOperatedLikesList(eventId, true, likesCount + 1);
                    break;
                case "unLiked successfully":
                    handelSetOperatedLikesList(eventId, false, likesCount - 1);
                    break;
                default:
                    break;
            }
        })
        .catch((error: AxiosError) => {
            const errorMessage = (error.response?.data as { message: string })
                ?.message;
            throw customError(errorMessage);
        });
};

export default toggleEventLikes;
